module.exports = __webpack_public_path__ + "media/05 hassle.7d5738bc.mp3";